"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _reactRedux = require("react-redux");
var R = _interopRequireWildcard(require("ramda"));
var _selectors = require("./store/selectors");
var _componentsCache = require("./componentsCache");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var rootNode = document.querySelector('body');
var ModalDispatcher = function ModalDispatcher() {
  var modals = (0, _reactRedux.useSelector)(_selectors.getOpenModals);
  var modalsJSX = (0, _react.useMemo)(function () {
    return R.map(function (_ref) {
      var key = _ref.key,
        mapActions2Store = _ref.mapActions2Store,
        props = _ref.props,
        onClose = _ref.onClose;
      var Component = (0, _componentsCache.getComponent)(key);
      return /*#__PURE__*/_react.default.createElement(Component, {
        key: key,
        mapActions2Store: mapActions2Store,
        modalKey: key,
        props: props,
        onClose: onClose
      });
    }, modals);
  }, [modals]);
  return !R.isEmpty(modalsJSX) && (0, _reactDom.createPortal)(modalsJSX, rootNode);
};
var _default = exports.default = ModalDispatcher;